export default __webpack_public_path__ + "896c335d7f8f067cd84e442c20ce404d.png";